import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const updateAbstractCourseNameOperation = async (
  abstractCourseId: number,
  name: string,
  courseHours: number,
  attendancePercentage: number,
  setLoading: (loading: boolean) => any,
  onHide: () => any,
) => {
  try {
    setLoading(true);
    await appApi.editAbstractCourse(
      abstractCourseId,
      name,
      courseHours,
      attendancePercentage,
    );
    globalSettingsStores.fetchSetting();
    setLoading(false);
    onHide();
  } catch (e) {
    setLoading(false);
    console.error(
      `updateAbstractCourseNameOperation is failed with the abstractCourseId: ${abstractCourseId}, name: ${name} with the error: ${e}`,
    );

    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
